import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './ListAppElement.scss'

import { Link } from 'react-router-dom'

const ListAppElement = props => (
	<Link to={'/apps/' + props.id} styleName="element">
		<div styleName="icon" />
		<div styleName="body">
			<div styleName="title">{props.title}</div>
			{props.desc ? <div styleName="desc">{props.desc}</div> : ''}
		</div>
		<div styleName="stats" />
	</Link>
)

ListAppElement.propTypes = {
	title: React.PropTypes.string,
	desc: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	])
}

export default CSSModules(ListAppElement, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/ListAppElement.js